/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Wed May 08 2024 08:29:37
 *
 *******************************************************/
//flow
import React from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Notification from 'src/components/containers/dashboard/notifications/notification';
import { URL } from 'src/constants/links';
import { TextStyle } from '@shopify/polaris';

type Props = { id: string, tenantId: string, onDismiss: Function };

type ComposedProps = Props & WithI18nProps;

const previewLink = {
  '5cd2eb-92.myshopify.com':
    'https://5cd2eb-92.myshopify.com/collections/all?preview_theme_id=167550058771',
  'aqmos-test.myshopify.com':
    'https://aqmos-test.myshopify.com/collections/all?preview_theme_id=167912735035',
  'hencadr.myshopify.com':
    'https://hencadr.myshopify.com/collections/all?preview_theme_id=135938179231',
  'panachebysharmeen.myshopify.com':
    'https://panachebysharmeen.myshopify.com/collections/all?preview_theme_id=127604588621'
};

const UpgradeLatestTurboTheme: React.FC<ComposedProps> = ({ i18n, id, tenantId, onDismiss }) => {
  const notification = {
    id,
    type: 'info',
    allowDismiss: true,
    title: i18n.translate('AdminHTML.Common.UpgradeLatestTurboTheme.title'),
    contentHtml: i18n.translate('AdminHTML.Common.UpgradeLatestTurboTheme.content', {
      t1: (
        <TextStyle variation="strong">
          {i18n.translate('AdminHTML.Common.UpgradeLatestTurboTheme.content_t1')}
        </TextStyle>
      ),
      t2: (
        <TextStyle variation="strong">
          {i18n.translate('AdminHTML.Common.UpgradeLatestTurboTheme.content_t2')}
        </TextStyle>
      )
    }),
    actionLabel: i18n.translate('AdminHTML.Common.Action.preview'),
    action: previewLink[tenantId],
    secondaryActionLabel: i18n.translate('AdminHTML.Common.Action.learnMore'),
    secondaryAction: URL['Link_Manage_Your_Template_Product_List']
  };
  return (
    <div>
      <Notification status={notification.type} notification={notification} onDismiss={onDismiss} />
    </div>
  );
};

export default withI18n()(UpgradeLatestTurboTheme);
